import axios, { AxiosResponse } from 'axios';
import { IXmlTariffCalculatePriceModel, IXmlTariffFilterModel, IXmlTariffModel } from './XmlTariffModel';
import { ApiResponse, PageResponse } from '../../../../shared/models/ApiModels';


const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')

// Endpoints
export const XMLTARIFF_CREATE_URL = `${API_URL}api/v1/definition/xmlRate/create`;
export const XMLTARIFF_GET_ALL_URL = `${API_URL}api/v1/definition/xmlRate/all`;
export const XMLTARIFF_DELETE_URL = `${API_URL}api/v1/definition/xmlRate/delete/`;
export const XMLTARIFF_UPDATE_URL = `${API_URL}api/v1/definition/xmlRate/update/`;
export const GET_BY_RESERVATION_ID_URL = `${API_URL}api/v1/definition/xmlRate/getByReservationId/`;
export const XMLTARIFF_GET_BY_ID_URL = `${API_URL}api/v1/definition/xmlRate/getById/`;
export const XMLTARIFF_FILTER_URL = `${API_URL}api/v1/definition/xmlRate/search`;
export const XMLTARIFF_GET_PRICE_URL = `${API_URL}api/v1/definition/xmlRate/calculateDailyPrices`;

export function getXmlTariffById(
  id: string
): Promise<AxiosResponse<ApiResponse<IXmlTariffModel>>> {
  return axios.get(XMLTARIFF_GET_BY_ID_URL + encodeURIComponent(id))
}

export function createXmlTariff(xmlTariff: IXmlTariffModel) {
  return axios.post(XMLTARIFF_CREATE_URL, xmlTariff);
}
 
export function updateXmlTariff(xmlTariff: IXmlTariffModel) {
  return axios.patch(XMLTARIFF_UPDATE_URL + xmlTariff.id, xmlTariff);
}
 
export async function loadXmlTariffs(
  page = 0,
  size = 5,
  sort: string = 'createdDate',
  order: string = 'desc',
  filters: IXmlTariffFilterModel = {
    statusSearch: 'true',
    approvalStatusSearch: 'APPROVED'
  }
): Promise<AxiosResponse<ApiResponse<PageResponse<IXmlTariffModel>>>> {
  return axios.post(XMLTARIFF_FILTER_URL, filters, {
    params: { page, size, sort, order }
  });
}
 
export function deleteXmlTariff(xmlTariffId: string) {
  return axios.delete(XMLTARIFF_DELETE_URL + xmlTariffId);
}
 
export async function getXmlTariffByReservationId(reservationId: string): Promise<AxiosResponse<ApiResponse<IXmlTariffModel>>> {
  return axios.get(GET_BY_RESERVATION_ID_URL+reservationId);
}

export async function getTotalPrice(xmlTariffCalculatePriceModel: IXmlTariffCalculatePriceModel): Promise<AxiosResponse<ApiResponse<number>>> {
  return axios.post(XMLTARIFF_GET_PRICE_URL, xmlTariffCalculatePriceModel);
}
